import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Search, Lock, Crown } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';

// PRO-only filter panel (search + tag + BPM range) when isPremium &&
// showFilters && there are recordings. For FREE users with recordings,
// shows the locked banner with the Upgrade CTA instead.

const RecordingsFilters = ({
  isPremium,
  showFilters,
  recordings,
  searchQuery, setSearchQuery,
  filterTag, setFilterTag,
  filterBpmMin, setFilterBpmMin,
  filterBpmMax, setFilterBpmMax,
  allTags,
  filteredRecordings,
  onResetFilters,
}) => {
  if (recordings.length === 0) return null;
  return (
    <>
      {isPremium && showFilters && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="bg-purple-500/10 border border-purple-500/30 rounded-xl p-4 mb-4"
        >
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <div>
              <label className="text-xs text-zinc-400 mb-1 block">Cerca titolo</label>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
                <Input
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Cerca..."
                  className="pl-9 bg-[#0A0A0A] border-white/10 text-white h-9"
                />
              </div>
            </div>
            <div>
              <label className="text-xs text-zinc-400 mb-1 block">Tag</label>
              <select
                value={filterTag}
                onChange={(e) => setFilterTag(e.target.value)}
                className="w-full h-9 bg-[#0A0A0A] border border-white/10 rounded-md text-white px-3 text-sm"
              >
                <option value="">Tutti</option>
                {allTags.map((tag) => (
                  <option key={tag} value={tag}>{tag}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-xs text-zinc-400 mb-1 block">BPM Min</label>
              <Input
                type="number"
                value={filterBpmMin}
                onChange={(e) => setFilterBpmMin(e.target.value)}
                placeholder="60"
                className="bg-[#0A0A0A] border-white/10 text-white h-9"
              />
            </div>
            <div>
              <label className="text-xs text-zinc-400 mb-1 block">BPM Max</label>
              <Input
                type="number"
                value={filterBpmMax}
                onChange={(e) => setFilterBpmMax(e.target.value)}
                placeholder="200"
                className="bg-[#0A0A0A] border-white/10 text-white h-9"
              />
            </div>
          </div>
          <div className="flex justify-between items-center mt-3">
            <span className="text-purple-400 text-sm">
              {filteredRecordings.length} di {recordings.length} registrazioni
            </span>
            <Button variant="ghost" size="sm" onClick={onResetFilters} className="text-zinc-400">
              Reset filtri
            </Button>
          </div>
        </motion.div>
      )}

      {!isPremium && (
        <div className="bg-zinc-800/50 border border-white/5 rounded-xl p-4 mb-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Lock className="w-4 h-4 text-zinc-600" />
            <span className="text-zinc-500 text-sm">Filtri avanzati disponibili in PRO</span>
          </div>
          <Link to="/premium">
            <Button size="sm" variant="ghost" className="text-amber">
              <Crown className="w-4 h-4 mr-1" />
              Upgrade
            </Button>
          </Link>
        </div>
      )}
    </>
  );
};

export default RecordingsFilters;
